import { MapDelta } from "./map/map"
import { Coordinate } from "./models"

export interface TileInteraction { name: string; displayName: string }
export interface TileInteractionTarget {
    coordinate: Coordinate
    layerId: string
    interactions: TileInteraction[]
}

/** Tile campaigns advertise verbs on map deltas; caps resolve to their parent tile. */
export const tileInteractionsAt = (
    provider: { getMapDeltaAt: (x: number, y: number, layerId: string) => MapDelta },
    cell: Coordinate,
): TileInteractionTarget | undefined => {
    if (!cell || !Number.isInteger(cell.x) || !Number.isInteger(cell.y)) return
    for (const layerId of ["sprite3", "sprite2", "sprite", "map3", "map2"]) {
        const hit = provider.getMapDeltaAt(cell.x, cell.y, layerId)
        if (!hit || hit.removed) continue
        const coordinate = hit.context?.parent || cell
        const tile = provider.getMapDeltaAt(coordinate.x, coordinate.y, layerId)
        const interactions = tile && !tile.removed ? tile.context?.tileInteractions : undefined
        if (interactions?.length) return { coordinate: { ...coordinate }, layerId, interactions }
    }
}
